{
  "COMPLEX": "Complex Trust",
  "SIMPLE": "Simple Trust",
  "GRANTOR": "Grantor Trust"
}
